import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { GalleriaComponent } from '@zaoblako/web/shared/dumbs/galleria/galleria.component';

@Component({
  selector: 'crm-image',
  standalone: true,
  styleUrls: ['./image.component.scss'],
  imports: [CommonModule, GalleriaComponent],
  templateUrl: './image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ImageComponent {
  @ContentChild('indicatorTemplate') public indicatorTemplate;

  public visible = false;

  @Input() public preview = true;
  @Input() public isShowIndicator = true;
  @Input() public style: any;
  @Input() public styleClass: string;
  @Input() public imageStyle: any;
  @Input() public imageClass: string;
  @Input() public src: string;
  @Input() public alt: string;
  @Input() public width: string;
  @Input() public height: string;
  @Input() public appendTo: string;

  @Output() public onClickImage = new EventEmitter<void>();
}
